const getProducts = `query GetProducts($where: ProductWhereInput, $search: String, $skip: Int, $first: Int) {
      allProducts(where: $where, search: $search, skip: $skip, first: $first) {
        id
        name
        images {
          id
          name
          link
          photo {
            filename
            publicUrl
          }
        }
        originId
        vin
        miles
        price
        carfax_1_owner
        carfax_clean_title
        exterior_color
        interior_color
        msrp
        inventory_type
        stock_no
        ref_price
        ref_miles
        year
        make
        model
        trim
        body_type
        body_subtype
        vehicle_type
        transmission
        drivetrain
        fuel_type
        engine
        engine_size
        engine_block
        doors
        cylinders
        ownerOrigin
        dealer {
          id
          city
          country
          dealer_type
          name
          state
          street
          website
          zip
        }
      }
    }`;
export default getProducts;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LXByb2R1Y3RzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vYXBwcy9ib3RzL2RlYWxlcmRpcmVjdC93ZWJ2aWV3L3NyYy9hcHAvcHJvZHVjdC9nZXQtcHJvZHVjdHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxXQUFXLEdBQUc7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztNQXNEZCxDQUFDO0FBRVAsZUFBZSxXQUFXLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBnZXRQcm9kdWN0cyA9IGBxdWVyeSBHZXRQcm9kdWN0cygkd2hlcmU6IFByb2R1Y3RXaGVyZUlucHV0LCAkc2VhcmNoOiBTdHJpbmcsICRza2lwOiBJbnQsICRmaXJzdDogSW50KSB7XG4gICAgICBhbGxQcm9kdWN0cyh3aGVyZTogJHdoZXJlLCBzZWFyY2g6ICRzZWFyY2gsIHNraXA6ICRza2lwLCBmaXJzdDogJGZpcnN0KSB7XG4gICAgICAgIGlkXG4gICAgICAgIG5hbWVcbiAgICAgICAgaW1hZ2VzIHtcbiAgICAgICAgICBpZFxuICAgICAgICAgIG5hbWVcbiAgICAgICAgICBsaW5rXG4gICAgICAgICAgcGhvdG8ge1xuICAgICAgICAgICAgZmlsZW5hbWVcbiAgICAgICAgICAgIHB1YmxpY1VybFxuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgICBvcmlnaW5JZFxuICAgICAgICB2aW5cbiAgICAgICAgbWlsZXNcbiAgICAgICAgcHJpY2VcbiAgICAgICAgY2FyZmF4XzFfb3duZXJcbiAgICAgICAgY2FyZmF4X2NsZWFuX3RpdGxlXG4gICAgICAgIGV4dGVyaW9yX2NvbG9yXG4gICAgICAgIGludGVyaW9yX2NvbG9yXG4gICAgICAgIG1zcnBcbiAgICAgICAgaW52ZW50b3J5X3R5cGVcbiAgICAgICAgc3RvY2tfbm9cbiAgICAgICAgcmVmX3ByaWNlXG4gICAgICAgIHJlZl9taWxlc1xuICAgICAgICB5ZWFyXG4gICAgICAgIG1ha2VcbiAgICAgICAgbW9kZWxcbiAgICAgICAgdHJpbVxuICAgICAgICBib2R5X3R5cGVcbiAgICAgICAgYm9keV9zdWJ0eXBlXG4gICAgICAgIHZlaGljbGVfdHlwZVxuICAgICAgICB0cmFuc21pc3Npb25cbiAgICAgICAgZHJpdmV0cmFpblxuICAgICAgICBmdWVsX3R5cGVcbiAgICAgICAgZW5naW5lXG4gICAgICAgIGVuZ2luZV9zaXplXG4gICAgICAgIGVuZ2luZV9ibG9ja1xuICAgICAgICBkb29yc1xuICAgICAgICBjeWxpbmRlcnNcbiAgICAgICAgb3duZXJPcmlnaW5cbiAgICAgICAgZGVhbGVyIHtcbiAgICAgICAgICBpZFxuICAgICAgICAgIGNpdHlcbiAgICAgICAgICBjb3VudHJ5XG4gICAgICAgICAgZGVhbGVyX3R5cGVcbiAgICAgICAgICBuYW1lXG4gICAgICAgICAgc3RhdGVcbiAgICAgICAgICBzdHJlZXRcbiAgICAgICAgICB3ZWJzaXRlXG4gICAgICAgICAgemlwXG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9YDtcblxuZXhwb3J0IGRlZmF1bHQgZ2V0UHJvZHVjdHM7XG4iXX0=